import home from './home'
import board from './board'
import attendance from './attendance'
import mypage from './mypage'
export default{
    home,
    board,
    attendance,
    mypage
}